import React, { createContext, useContext, useState } from 'react'

export const listFitlers = {
  LIST_FILTER_PROYECT: 'LIST_FILTER_PROYECT',
  LIST_FILTER_CTM_PROYECTS_TABS_UNASSIGNED: 'LIST_FILTER_CTM_PROYECTS_TABS_UNASSIGNED',
  LIST_FILTER_CTM_PROYECTS_TABS_MYPROJECTS: 'LIST_FILTER_CTM_PROYECTS_TABS_MYPROJECTS',
  LIST_FILTER_CTM_PROYECTS_TABS_ALL: 'LIST_FILTER_CTM_PROYECTS_TABS_ALL',
  LIST_FILTER_ENT_PROYECTS_TABS_MYPROJECTS: 'LIST_FILTER_ENT_PROYECTS_TABS_MYPROJECTS',
  LIST_FILTER_ENT_PROYECTS_TABS_ALL: 'LIST_FILTER_ENT_PROYECTS_TABS_ALL',
  LIST_FILTER_PROYECT_COMMERCIAL: 'LIST_FILTER_PROYECT_COMMERCIAL',
  LSIT_FILTER_INTERNAL_ENT_ANALYST: 'LSIT_FILTER_INTERNAL_ENT_ANALYST',
  LIST_FILTER_CTM_ACC_PAYMENTS: 'LIST_FILTER_CTM_ACC_PAYMENTS',
  LIST_FILTER_ENT_ACC_PAYMENTS: 'LIST_FILTER_ENT_ACC_PAYMENTS',
  LIST_FILTER_CTM_ACC_BILLING: 'LIST_FILTER_CTM_ACC_BILLING',
  LIST_FILTER_ENT_ACC_BILLING: 'LIST_FILTER_ENT_ACC_BILLING',
  LIST_FILTER_CTM_ACC_REPORTS: 'LIST_FILTER_CTM_ACC_REPORTS',
  LIST_FILTER_ENT_ACC_REPORTS: 'LIST_FILTER_ENT_ACC_REPORTS',
  EXTERNAL_PARAM_TAB_PAYMENTS: 'EXTERNAL_PARAM_TAB_PAYMENTS',
  EXTERNAL_PARAM_TAB_BILLING: 'EXTERNAL_PARAM_TAB_BILLING',
  EXTERNAL_PARAM_TAB_REPORTS: 'EXTERNAL_PARAM_TAB_REPORTS',
}

const PAGE = 1

const initialContext = {
  listQuerying: {},
  setListQuerying() {},
  getQueryByName() {},
  putQueryByName() {},
  removeQuerying() {},
  removeQueryByName() {},
  getExternalParam() {},
}

export const TableQueryContext = createContext(initialContext)

export function useTableQueryingContext() {
  return useContext(TableQueryContext)
}

const TableQueryProvider = ({ children }) => {
  const [listQuerying, setListQuerying] = useState({})

  const putQueryByName = ({ filterName, columns, params, extraParams = undefined }) => {
    const filters = columns
      .map((c, index) => ({
        name: c.name,
        filterList: c.options?.filterList,
        index: index,
      }))
      .filter((c) => c.filterList && c.filterList.length !== 0)
    let sort = undefined
    if (params.sort) {
      sort = params.sort
    }
    let page = PAGE
    if (params.page && params.page !== PAGE) {
      page = params.page
    }

    setListQuerying((prev) => ({
      ...prev,
      [filterName]: {
        filters: filters,
        sort: sort,
        page: page,
        extraParams: extraParams,
      },
    }))
  }

  const getQueryByName = ({ filterName, columns }) => {
    const result = {
      columns: columns,
      sort: undefined,
      page: PAGE,
      extraParams: undefined,
    }
    if (listQuerying && Object.keys(listQuerying).length !== 0) {
      const queryng = listQuerying[filterName]
      if (queryng) {
        queryng.filters.forEach((key) => {
          columns
            .filter((c) => c.name === key.name && c.options)
            .forEach((c) => (c.options.filterList = key.filterList))
        })
        result.columns = columns
        if (queryng.sort) {
          let sort = queryng.sort
          let name
          if (Array.isArray(sort)) {
            name = columns
              .filter((c) => c.sortQuery && Array.isArray(c.sortQuery))
              .filter(
                (c) =>
                  c.sortQuery.length === sort.length &&
                  c.sortQuery.every(function (value, index) {
                    return value === sort[index].replace('asc', '{0}').replace('desc', '{0}')
                  }),
              )
              .map((c) => c.name)[0]
          } else if (!Array.isArray(sort)) {
            name = columns
              .filter((c) => sort.replace('asc(', '').replace('desc(', '').replace(')', '') === c.name)
              .map((c) => c.name)[0]
          }
          const sortOptions = {
            name: name,
            direction: Array.isArray(sort)
              ? sort[0].includes('asc')
                ? 'asc'
                : 'desc'
              : sort.includes('asc')
                ? 'asc'
                : 'desc',
          }
          result.sort = {
            sortQuery: queryng.sort,
            sortOptions: sortOptions,
          }
        }
        if (queryng.page && queryng.page !== PAGE) {
          result.page = queryng.page
        }
        result.extraParams = queryng.extraParams
      }
    }
    return result
  }

  const getExternalParam = ({ filterName }) => {
    if (listQuerying && Object.keys(listQuerying).length !== 0) {
      const queryng = listQuerying[filterName]
      if (queryng) {
        return queryng.extraParams
      }
    }
    return undefined
  }

  const removeQuerying = () => {
    setListQuerying({})
  }

  const removeQueryByName = (filterName) => {
    delete listQuerying[filterName]
    setListQuerying(listQuerying)
  }

  return (
    <TableQueryContext.Provider
      value={{
        putQueryByName: putQueryByName,
        getQueryByName: getQueryByName,
        removeQuerying: removeQuerying,
        removeQueryByName: removeQueryByName,
        getExternalParam: getExternalParam,
      }}>
      {children}
    </TableQueryContext.Provider>
  )
}

export default TableQueryProvider
